// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-j_gG","advertDetailHeaderPrice__value":"c-j_gH","advertDetailHeaderPrice__label":"c-j_gJ"};